import { UserInfo } from "./userInfo.class";
import { RoleInfo } from "./roleInfo.class";

export class UserManagerState {
    users: UserInfo[] = [];
    roles: RoleInfo[] = [];
    userToEdit: UserInfo = null;
    returnFromEdit: boolean = false;
}